export default "__VITE_ASSET__Cf95XC0l__"